import { Injectable } from '@angular/core';
import { SpecialBlock } from '@core/models/block/special-block';
import { Adapter } from '@core/interfaces/adapter';
import { isSpecialBlock } from '@shared/helpers/block-helpers';
import { Block } from '@core/models/block/block.model';
import { Page } from '@core/interfaces/page.interface';

export const createByNode = (block: Block): Block => Block.create(block);

export const createTypesRecursive = (children: Block[] = []): Block[] => {
  const blocks: Block[] = [];
  for (const blk of children) {
    const block = createByNode(blk);

    if (blk.children.length > 0) {
      block.children = createTypesRecursive(blk.children);
    }
    // map special block children

    if (isSpecialBlock(block)) {
      block.specialBlock = mapSpecialBlock(block.specialBlock);
    }
    blocks.push(block);
  }
  return blocks;
};

export const mapSpecialBlock = (block: Block | any): SpecialBlock => {
  const {children} = block;

  // create typed children
  const childs = createTypesRecursive(children);
  return SpecialBlock.create({...block, children: childs});
};

@Injectable({
  providedIn: 'root',
})
export class ClientPageAdapter implements Adapter<Page> {
  adapt(item: any): Page {
    const {blocks} = item;

    const childs = createTypesRecursive(blocks);

    return {...item, blocks: childs};
  }
}

@Injectable({
  providedIn: 'root',
})
export class BlockAdapter implements Adapter<Block> {
  adapt(item: any): Block {
    return mapSpecialBlock(item);
  }
}
